import { render, staticRenderFns } from "./TheSnackbar.vue?vue&type=template&id=38196b34&scoped=true"
import script from "./TheSnackbar.vue?vue&type=script&lang=js"
export * from "./TheSnackbar.vue?vue&type=script&lang=js"
import style0 from "./TheSnackbar.vue?vue&type=style&index=0&id=38196b34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38196b34",
  null
  
)

export default component.exports